import React, { useCallback, useState } from 'react';
import ScanToReceiveDialog from './ScanToReceiveDialog';
import ReceiveSummaryDialog from './ScanResultDialog';
type Props = {
  targetStrs: {id:string, sku: string, upc: string, lotNumber: string, uom: string, fulfillmentReturnLineNum: number}[];
  uomEnable: boolean;
  lotEnable: boolean;
  onHide: () => void;
  onSuccess: (
    data: { sku: string; quantity: number; product: ProductRow }[]
  ) => void;
};
// eslint-disable-next-line
export default (props: Props) => {
  const [step, setStep] = useState<number>(1);
  const { onHide, onSuccess, uomEnable, lotEnable } = props;
  const [items, setItems] = useState<any[]>();
  const [defaultData, setDefaultData] = useState<any[]>([]);
  const [defaultStr, setDefaultStr] = useState<string>('');
  const [defaultTab, setDefaultTab] = useState('single');

  /**
   * handle scan to move submit event
   * 2024100001164-4
   */
  const handleScanToReceiveSubmit = useCallback(
    (
      items: any[],
      data: any[],
      str: string,
      tab: string
    ) => {
      setItems(items);
      setDefaultData(data);
      setDefaultStr(str);
      setStep(2);
      setDefaultTab(tab);
    },
    []
  );
  if (step === 1) {
    return (
      <ScanToReceiveDialog
        defaultTab={defaultTab}
        defaultData={defaultData}
        defaultStr={defaultStr}
        skuList={props.targetStrs}
        onSubmit={handleScanToReceiveSubmit}
        onHide={onHide}
        uomEnable={uomEnable}
        lotEnable={lotEnable}
      />
    );
  } else if (step === 2 && items) {
    return (
      <ReceiveSummaryDialog
        items={items}
        lotEnable={lotEnable}
        uomEnable={uomEnable}
        ids={props.targetStrs.map(i=>i.id)}
        onHide={(data)=>data ? onSuccess(data) : onHide()}
        reback={() => {
          setItems(undefined);
          setStep(1);
        }}
      />
    );
  }
  return null;
};
